import { Color } from './types';

// Note(gb): this way you can preserve type info without extra castings
const WHITE_100: Color = [255, 255, 255];
const WHITE_80: Color = [255, 255, 255, 204];
const WHITE_75: Color = [255, 255, 255, 192];
const WHITE_50: Color = [255, 255, 255, 128];
const WHITE_25: Color = [255, 255, 255, 64];
const WHITE_16: Color = [255, 255, 255, 41];
const WHITE_10: Color = [255, 255, 255, 25];
const WHITE_5: Color = [255, 255, 255, 12];
const WHITE_0: Color = [255, 255, 255, 0];
const BLACK_100: Color = [0, 0, 0];
const BLACK_75: Color = [0, 0, 0, 192];
const BLACK_50: Color = [0, 0, 0, 128];
const BLACK_25: Color = [0, 0, 0, 64];
const BLACK_10: Color = [0, 0, 0, 25];
const DARKGREY1_100: Color = [64, 64, 64];
const DARKGREY2_100: Color = [128, 128, 128];
const LIGHTGREY1_100: Color = [230, 230, 230];
const LIGHTGREY1_75: Color = [230, 230, 230, 192];
const LIGHTGREY2_100: Color = [200, 200, 200];

const GAINSBORO: Color = [242, 243, 246]; //#F2F3F6
const GUNMETAL: Color = [35, 60, 75]; //#233B4B
const GUNMETAL_HL: Color = [20, 40, 50]; //#233B4B
const GUNMETAL_HL2: Color = [45, 80, 95];
const BLUE_CRAYOLA: Color = [35, 140, 231]; //#218CE7
const BLUE_HIGHLIGHT: Color = [0, 158, 250]; //#8BBDE5

const BLUE_LIGHT: Color = [138, 180, 248]; //#8BBDE5
const BLUE_NAME_LIGHT: Color = [200, 210, 255]; //#8BBDE5
const RED_SALSA: Color = [255, 60, 75]; //#FF3B4B
const RED_DARK: Color = [145, 32, 30]; //#FF3B4B
const RED_DARK_HL: Color = [174, 38, 36]; //#FF3B4B
const RED_HIGHLIGHT: Color = [229, 123, 132]; //#E57B84
const GREEN_100: Color = [0, 163, 123];
const GREEN_HIGHLIGHT: Color = [30, 183, 153];
const GREEN_LIGHT: Color = [191, 255, 208];
const GREEN_DARK: Color = [21, 92, 63];
const GREEN_DARK_HIGHLIGHT: Color = [33, 120, 84];

export const GREEN_BUTTON: Color = [202, 233, 35];
export const GREEN_BUTTON_HL: Color = [202 * 1.3, 233 * 1.3, 35 * 1.3];

const GREEN_25: Color = [...GREEN_100, 64];
const GREEN_50: Color = [...GREEN_100, 128];

const ORANGE: Color = [228, 156, 54];
const ORANGE_25: Color = [...ORANGE, 64];
const ORANGE_50: Color = [...ORANGE, 128];

const RED_25: Color = [...RED_SALSA, 64];
const RED_50: Color = [...RED_SALSA, 128];

const COLOR_TRANSPARENT: Color = [0, 0, 0, 0];
const COLOR_MY_NAME: Color = [174, 204, 229];
const MODULE_PART_LOCKED: Color = [194, 194, 194, 150];
const MODULE_PART_COMPLETED: Color = [123, 224, 133];

const COLOR_INSTRUCTION_BAR: Color = [0, 0, 0, 50];
const COLOR_RESILIENCE_CANVAS: Color = [243, 244, 245];
const COLOR_MODULE_PART_VIDEO: Color = [98, 102, 174];
const COLOR_MODULE_PART_ARTICLE: Color = [128, 91, 64];
const COLOR_MODULE_PART_SOLO: Color = [165, 138, 39];
const COLOR_MODULE_PART_SOCIAL: Color = [203, 121, 2];
const COLOR_MODULE_PART_FEEDBACK: Color = [155, 190, 17];
const COLOR_MODULE_PART_PLAN: Color = [226, 150, 31];
const COLOR_VIDEOCALL_BACKGROUND: Color = [28, 32, 37, 255];
const COLOR_WARNING: Color = [244, 244, 137, 255];

const COLOR_NEW_BLUE_LIGHT: Color = [31, 206, 249];
const COLOR_NEW_BLUE_DARK: Color = [21, 48, 110];

const COLOR_NEW_GREEN_LIGHT: Color = [25, 229, 107];
const COLOR_NEW_GREEN_DARK: Color = [43, 75, 80];

const COLOR_NEW_BLACK: Color = [10, 23, 23];
const COLOR_NEW_GREY: Color = [82, 82, 82];

const COLOR_NEW_ORANGE_LIGHT: Color = [255, 145, 15];
const COLOR_NEW_ORANGE_DARK: Color = [78, 44, 34];

const COLOR_NEW_PURPLE_LIGHT: Color = [244, 119, 254];
const COLOR_NEW_PURPLE_DARK: Color = [57, 28, 73];

export const COLORS = {
  NEW_STYLE: {
    GREEN_LIGHT: COLOR_NEW_GREEN_LIGHT,
    GREEN_DARK: COLOR_NEW_GREEN_DARK,
    BLUE_LIGHT: COLOR_NEW_BLUE_LIGHT,
    BLUE_DARK: COLOR_NEW_BLUE_DARK,
    ORANGE_LIGHT: COLOR_NEW_ORANGE_LIGHT,
    ORANGE_DARK: COLOR_NEW_ORANGE_DARK,
    PURPLE_LIGHT: COLOR_NEW_PURPLE_LIGHT,
    PURPLE_DARK: COLOR_NEW_PURPLE_DARK,
    BLACK: COLOR_NEW_BLACK,
    GREY: COLOR_NEW_GREY,
    RED: RED_SALSA,
  },
  TRANSPARENT: COLOR_TRANSPARENT,
  LIGHTGREY1_100: LIGHTGREY1_100,
  LIGHTGREY1_75: LIGHTGREY1_75,
  LIGHTGREY2_100: LIGHTGREY2_100,
  DARKGREY1_100: DARKGREY1_100,
  DARKGREY2_100: DARKGREY2_100,
  WHITE_100: WHITE_100,
  WHITE_80: WHITE_80,
  WHITE_75: WHITE_75,
  WHITE_50: WHITE_50,
  WHITE_25: WHITE_25,
  WHITE_16: WHITE_16,
  WHITE_10: WHITE_10,
  WHITE_5: WHITE_5,
  WHITE_0: WHITE_0,
  BLACK_100: BLACK_100,
  BLACK_75: BLACK_75,
  BLACK_50: BLACK_50,
  BLACK_25: BLACK_25,
  BLACK_10: BLACK_10,
  ORANGE_25: ORANGE_25,
  ORANGE_50: ORANGE_50,
  ORANGE_100: ORANGE,
  RED_25: RED_25,
  RED_50: RED_50,
  GAINSBORO: GAINSBORO,
  WARNING: COLOR_WARNING,
  GUNMETAL: GUNMETAL,
  GUNMETAL_HL: GUNMETAL_HL,
  GUNMETAL_HL2: GUNMETAL_HL2,
  BLUE_CRAYOLA: BLUE_CRAYOLA,
  BLUE_HIGHLIGHT: BLUE_HIGHLIGHT,
  BLUE_LIGHT: BLUE_LIGHT,
  BLUE_NAME_LIGHT: BLUE_NAME_LIGHT,
  RED_SALSA: RED_SALSA,
  RED_DARK: RED_DARK,
  RED_DARK_HL: RED_DARK_HL,
  RED_HIGHLIGHT: RED_HIGHLIGHT,
  GREEN_100: GREEN_100,
  GREEN_HIGHLIGHT: GREEN_HIGHLIGHT,
  GREEN_LIGHT: GREEN_LIGHT,
  GREEN_DARK: GREEN_DARK,
  GREEN_DARK_HIGHLIGHT: GREEN_DARK_HIGHLIGHT,
  GREEN_25: GREEN_25,
  GREEN_50: GREEN_50,
  QUESTION: WHITE_25,
  MY_NAME: COLOR_MY_NAME,
  MODULE_PART_LOCKED,
  MODULE_PART_COMPLETED,
  INSTRUCTION_BAR: COLOR_INSTRUCTION_BAR,
  RESILIENCE_CANVAS: COLOR_RESILIENCE_CANVAS,
  MODULE_PART_VIDEO: COLOR_MODULE_PART_VIDEO,
  MODULE_PART_ARTICLE: COLOR_MODULE_PART_ARTICLE,
  MODULE_PART_SOLO: COLOR_MODULE_PART_SOLO,
  MODULE_PART_SOCIAL: COLOR_MODULE_PART_SOCIAL,
  MODULE_PART_FEEDBACK: COLOR_MODULE_PART_FEEDBACK,
  MODULE_PART_PLAN: COLOR_MODULE_PART_PLAN,
  VIDEOCALL_BACKGROUND: COLOR_VIDEOCALL_BACKGROUND,
} as const;
